import Vehicle from '@adaptors-api/vehicle-api';
import { IMeta } from '@interfaces/imeta';
import { IVehicle, IVehicleType } from '@interfaces/ivehicle';
import { isFetchingData, setMetaData, setNotification } from '@pages/base/action';
import ActionTypes from '@store/action-types';
import { EnumLoading, DataName } from '@utils/constants';
import RequestAPI from '@utils/request-api';

const setLoading = (dispatch: any) => {
  dispatch(isFetchingData(EnumLoading.SET, DataName.VEHICLE));
};
const unsetLoading = (dispatch: any) => {
  dispatch(isFetchingData(EnumLoading.REMOVE, DataName.VEHICLE));
};

export const setVehicleTypeList = (vehicleTypeList: IVehicleType[]) => ({
  vehicleTypeList,
  type: ActionTypes.PAGE_VEHICLE_SET_VEHICLE_TYPE_LIST,
});

export const setVehicle = (vehicle?: IVehicle) => ({
  vehicle,
  type: ActionTypes.PAGE_VEHICLE_SET_VEHICLE,
});

export const setVehicleList = (vehicleList: IVehicle[]) => ({
  vehicleList,
  type: ActionTypes.PAGE_VEHICLE_SET_VEHICLE_LIST,
});

export const fetchVehicle = (code: string) => (dispatch: any) => {
  setLoading(dispatch);

  if (!code) {
    dispatch(setVehicle(undefined));
    unsetLoading(dispatch);
    return;
  }

  return RequestAPI(Vehicle.getVehicle(code))
    .then((response: any) => {
      const { data } = response.data;
      const vehicle: IVehicle = data;
      dispatch(setVehicle(vehicle));
      unsetLoading(dispatch);
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
    });
};

export const fetchVehicleTypeList = (params?: any, isSetMeta: boolean = true) => (
  dispatch: any,
) => {
  setLoading(dispatch);

  return RequestAPI(Vehicle.getVehicleTypes(params))
    .then((response: any) => {
      const { data, meta } = response.data;
      const vehicleTypeList: IVehicleType[] = data;
      const metaData: IMeta = meta;
      dispatch(setVehicleTypeList(vehicleTypeList));
      if (isSetMeta) {
        dispatch(setMetaData(metaData));
      }
      unsetLoading(dispatch);
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
    });
};

export const fetchVehicleList = (params?: any, isSetMeta: boolean = true) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(Vehicle.getVehicles(params))
    .then((response: any) => {
      const { data, meta } = response.data;
      const vehicleList: IVehicle[] = data;
      const metaData: IMeta = meta;
      dispatch(setVehicleList(vehicleList));
      if (isSetMeta) {
        dispatch(setMetaData(metaData));
      }
      unsetLoading(dispatch);
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
    });
};

export const fetchExpiredVehicleList = () => {
  return RequestAPI(Vehicle.getVehicles({ isExpired: true }))
    .then((response: any) => {
      const { data } = response.data;
      return data;
    })
    .catch((e: Error) => {
      return undefined;
    });
};

export const createVehicleType = (body: IVehicleType) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(Vehicle.createVehicleType(body))
    .then((response: any) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: response.status === 200 ? 'success' : 'error',
        title: `Buat Tipe Kendaraan ${response.status === 200 ? 'Sukses' : 'Gagal'}`,
        message: response.data.message,
      };
      dispatch(setNotification(notif));
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: 'error',
        title: `Buat Tipe Kendaraan Gagal`,
        message: e.message,
      };
      dispatch(setNotification(notif));
    });
};

export const updateVehicleType = (code: string, body: IVehicleType) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(Vehicle.updateVehicleType(code, body))
    .then((response: any) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: response.status === 200 ? 'success' : 'error',
        title: `Ubah Tipe Kendaraan ${response.status === 200 ? 'Sukses' : 'Gagal'}`,
        message: response.data.message,
      };
      dispatch(setNotification(notif));
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: 'error',
        title: `Ubah Tipe Kendaraan Gagal`,
        message: e.message,
      };
      dispatch(setNotification(notif));
    });
};

export const createVehicle = (body: IVehicle) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(Vehicle.createVehicle(body))
    .then((response: any) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: response.status === 200 ? 'success' : 'error',
        title: `Buat Kendaraan ${response.status === 200 ? 'Sukses' : 'Gagal'}`,
        message: response.data.message,
      };
      dispatch(setNotification(notif));
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: 'error',
        title: `Buat Kendaraan Gagal`,
        message: e.message,
      };
      dispatch(setNotification(notif));
    });
};

export const updateVehicle = (code: string, body: IVehicle) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(Vehicle.updateVehicle(code, body))
    .then((response: any) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: response.status === 200 ? 'success' : 'error',
        title: `Ubah Kendaraan ${response.status === 200 ? 'Sukses' : 'Gagal'}`,
        message: response.data.message,
      };
      dispatch(setNotification(notif));
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: 'error',
        title: `Ubah Kendaraan Gagal`,
        message: e.message,
      };
      dispatch(setNotification(notif));
    });
};
